// The Facebook Connections search matches names and ids alike: a person, system user, Business Manager, business,
// or an Ad Account / Page id pasted from Facebook. An ad account id matches with or without its act_ prefix.

export const normalizeSearch = (query: string) => query.toLowerCase().trim().replace(/^act_/, '')

export const textMatches = (value: string | number | null | undefined, query: string) =>
  value !== null &&
  value !== undefined &&
  String(value).toLowerCase().replace(/^act_/, '').includes(query)

// one business under a system user or person: its name, Marketing Milk id, or any of its Facebook asset ids
export const businessMatches = (
  business: { business_id: number; business_name: string },
  assetIDs: (string | null | undefined)[],
  query: string
) =>
  textMatches(business.business_name, query) ||
  textMatches(business.business_id, query) ||
  assetIDs.some(id => textMatches(id, query))
